import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, SelectProfile } from 'types';
import { client } from 'utils/api-client';

const impersonate = (payload: SelectProfile): Promise<AxiosResponse<string>> => {
  return client.post('/auth/impersonate/', payload);
};

export default function useImpersonate(): UseMutationResult<
  AxiosResponse<string>,
  AxiosError<ErrorMessage>,
  SelectProfile
> {
  return useMutation(impersonate);
}
